///////////////////////
/// helper functions //
///////////////////////

function isUndefined(obj) {
  return typeof obj === 'undefined';
}

function isNumeric(number) {
  if(isUndefined(number)){
    return false;
  }
  return !isNaN(number) && isFinite(number);
}

function numberFormat(x) {
  var y = x.toString().split('.');
  if(x > 9999) {y[0] = y[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');}
  return y.join(','); 
}

function isWebGLSupported() {
  var canvas = document.createElement('canvas');
  var gl = null;
  
  try { 
    gl = canvas.getContext('webgl'); 
  }
  catch (x) { 
    gl = null; 
  }

  if (gl == null) {
    try { 
      gl = canvas.getContext('experimental-webgl'); 
    }
    catch (x) { 
      gl = null; 
    }
  }

  return !!gl;
};

///////////////////////
/// device detection //
///////////////////////

var oldBrowser, mobile, smartphone, clickEvent, isIE, isFirefox;

function initVars() {
  oldBrowser = !(('querySelector' in document) && ('localStorage' in window) && ('addEventListener' in window));
  mobile = !isUndefined(window.orientation);
  smartphone = /android.*mobile|mobile.*android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  clickEvent = mobile ? 'touchstart' : 'click';
  isIE = !!detectIE();
  isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

  if (mobile) {
    $('html').addClass('is-mobile');
  }
}

initVars();

// http://codepen.io/gapcode/pen/vEJNZN
function detectIE() {
  var ua = window.navigator.userAgent;
  
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

function isIOS8() {
  var deviceAgent = navigator.userAgent.toLowerCase();
  return /(iphone|ipod|ipad).* os 8_/.test(deviceAgent);
}


//////////////////
/// geo helpers //
//////////////////

var geo = {
	berlinCenter : [52.52, 13.4],
	berlinBounds : [[51, 12.924], [54.5, 13.8249]]
};

geo.geoCode = function(search) {
  var url = 'http://interaktiv.morgenpost.de/php-scripts/geocode.php?search=' + search;
  return $.ajax({
    url : url,
    type: 'GET',
    dataType: 'json'
  });
}

geo.reverseGeoCode = function(lat, lng) {

}

geo.getZoomByWindowSize = function() {
  var mapZoom = 11,
      screenWidth = window.innerWidth;
  if (smartphone || screenWidth < 500) {
    mapZoom = 10;
  }
  else if (screenWidth < 700) {
    mapZoom = 11;
  } else if (screenWidth < 1100) {
    mapZoom = 11;
  } else if (screenWidth > 2000) {
    mapZoom = 12;
  }
  return mapZoom;
}

// https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function isSmallScreen(){
  return window.innerWidth < 786;
}

//////////////////
/// api exports //
//////////////////
module.exports = {
	isUndefined : isUndefined,
	isNumeric : isNumeric,
	numberFormat : numberFormat,

	isOldBrowser : oldBrowser,
	isMobile : mobile,
	isSmartphone : smartphone,
  isIE: isIE,
  isFirefox: isFirefox,
  clickEvent : clickEvent,
	updateDevices : initVars,
  isWebGLSupported: isWebGLSupported,
  debounce: debounce,
  isSmallScreen: isSmallScreen,

	geo : geo
}